import React from 'react';
import { Button, message } from 'antd';
import { withRouter } from 'react-router-dom';
import { getSkillUser } from '../../../../../components/skills/skills_action';
import { useSelector, useDispatch } from 'react-redux';
const HeaderContent = (props) => {
  const {
    title,
    buttonName,
    buttonType,
    handleCustomize,
    hideCustomizeButtons,
    isPersonalApphome,
  } = props;
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.skills.skills);
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;

  const handleCustomizeRedirect = async () => {
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    const currentSkillUser = await dispatch(
      getSkillUser(props.match.params.wId, jiraSkill.skill_metadata._id)
    );
    const redirectTo =
      buttonType === 'issueList' ? 'jira_software' : 'jira_service_desk';
    if (!jiraSkill.skill_metadata.linked) {
      return message.error({
        content: (
          <>
            Jira is not connected. Click
            <a
              onClick={() => {
                props.history.push(
                  `/${props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/${redirectTo}?view=connection`
                );
              }}
            >
              {' '}
              here{' '}
            </a>
            to connect to your Jira.
          </>
        ),
      });
    }
    let isUserVerified = false;

    if (currentSkillUser && currentSkillUser.data.skillUser.token_obj) {
      isUserVerified = true;
    }
    if (!isUserVerified) {
      return message.error({
        content: (
          <>
            Verify your personal Jira connection. Click
            <a
              onClick={() => {
                props.history.push(
                  `/${props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/${redirectTo}?view=personal_preferences`
                );
              }}
            >
              {' '}
              here{' '}
            </a>
            to verify.
          </>
        ),
      });
    }

    if (isPersonalApphome) {
      props.history.push(
        `/${props.match.params.wId}/settings/personalapphome/customize?view=customizeData`
      );
    } else {
      props.history.push(
        `/${props.match.params.wId}/slackApp/apphome?view=customizeData`
      );
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '8px',
        }}
      >
        <div
          style={{ fontWeight: 600, fontSize: '16px', lineHeight: '12.5px' }}
        >
          {title}
        </div>

        {buttonName &&
          (buttonType === 'issueList' || buttonType === 'requestList' ? (
            <Button
              onClick={handleCustomizeRedirect}
              className='apphome_primary_buttons'
              type='primary'
              disabled={hideCustomizeButtons}
            >
              {buttonName}
            </Button>
          ) : (
            <Button
              onClick={handleCustomize}
              className='apphome_primary_buttons'
              type='primary'
              disabled={hideCustomizeButtons}
            >
              {buttonName}
            </Button>
          ))}
      </div>
      <div
        style={{
          borderBottom: `${
            isDarkTheme
              ? '1px solid rgba(255, 255, 255, 0.1)'
              : '1px solid rgba(0, 0, 0, 0.06)'
          }`,
        }}
        className='apphome_borders'
      ></div>
    </>
  );
};

export default withRouter(HeaderContent);
